import React from 'react';
import { CatalogUseCases } from '../../main/factories/catalog-dependencies.factory';
import { CatalogContext } from './catalog-context';

export const CatalogProvider: React.FC<{
  catalogUseCases: CatalogUseCases;
  children: React.ReactNode;
}> = ({ catalogUseCases, children }) => {
  return (
    <CatalogContext.Provider value={catalogUseCases}>
      {children}
    </CatalogContext.Provider>
  );
};
